// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"fded7413","298":"fa7e861e","453":"7abdf735","888":"384ed6d3"}[chunkId] + ".chunk.js";
};